import styled from '@emotion/styled';
import React from 'react';
import { useTranslation } from 'react-i18next';
import img from 'src/public/img/marginalia-shopping.svg';

import { Button } from 'src/shared/components/Button';
import { Modal } from 'src/shared/components/Modal';
import { color, font, mediaQueries } from 'src/shared/styles/variables';

interface StyledModalProps {
    fullscreen: boolean;
}

const StyledModal = styled(Modal)<StyledModalProps>(props => ({
    height: 'auto',
    '.ant-modal-content': {
        borderRadius: props.fullscreen ? 0 : 7.5,
        height: props.fullscreen ? '100vh' : 'auto',
        display: 'flex',
        flexFlow: 'column',
        justifyContent: 'center',
        alignItems: 'center',

        '.ant-modal-body': {
            padding: 0,
        },
    },
}));

const Wrapper = styled.div({
    padding: '63px 25px 45px',
    display: 'flex',
    margin: '0 auto',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: 560,
    [mediaQueries.md]: {
        padding: '36px 25px 26px',
    },
});

const HeaderText = styled.h3(
    {
        color: color.ebonyClay,
        textAlign: 'center',
        marginBottom: 0,
    },
    font.black(font.size.extraLarge),
);

const Text = styled.p(
    {
        textAlign: 'left',
        color: color.steelGray,
        lineHeight: '26px',
        marginTop: 22,
    },
    font.book(font.size.medium),
);

const ImageWrapper = styled.div({
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    overflowY: 'hidden',
    width: '100%',
    minHeight: '200px',
    marginBottom: 40,
});

const ButtonsWrapper = styled.div({
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    marginTop: 22,
});

interface Props {
    visible: boolean;
    onConfirm: () => void;
    onClose: () => void;
}

export const OldCostModal: React.FC<Props> = ({ visible, onClose, onConfirm }) => {
    const { t } = useTranslation();

    return (
        <StyledModal
            visible={visible}
            footer={null}
            width={500}
            onCancel={onClose}
            centered
            fullscreen={false}
        >
            <Wrapper>
                <ImageWrapper>
                    <img src={img} alt="marginalia-shopping" />
                </ImageWrapper>

                <HeaderText>{t(`payments:cost_modal.title`)}</HeaderText>

                <Text>{t(`payments:cost_modal.info`)}</Text>

                <Text>{t(`payments:cost_modal.description`)}</Text>

                <ButtonsWrapper>
                    <Button type="accept" onClick={onConfirm} noHorizontalPadding fullWidth>
                        {t('payments:proceed_pay')}
                    </Button>
                </ButtonsWrapper>
            </Wrapper>
        </StyledModal>
    );
};
